import { render, staticRenderFns } from "./FormHowMuchItem.vue?vue&type=template&id=fececd54&scoped=true"
import script from "./FormHowMuchItem.vue?vue&type=script&setup=true&lang=js"
export * from "./FormHowMuchItem.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FormHowMuchItem.vue?vue&type=style&index=0&id=fececd54&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fececd54",
  null
  
)

export default component.exports